module.exports = __webpack_public_path__ + "static/img/weixin.e83f0f9f.png";